import React from 'react';

const ChevronDown: React.FC<IconProps> = ({
    height,
    width,
    fillColor,
}) => {
    const h = height ?? 16;
    const w = width ?? 16;
    const fill = fillColor ?? "#282829";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M3.52859 5.52859C3.78894 5.26824 4.21105 5.26824 4.4714 5.52859L7.99999 9.05719L11.5286 5.52859C11.7889 5.26824 12.211 5.26824 12.4714 5.52859C12.7317 5.78894 12.7317 6.21105 12.4714 6.4714L8.4714 10.4714C8.21105 10.7318 7.78894 10.7318 7.52859 10.4714L3.52859 6.4714C3.26824 6.21105 3.26824 5.78894 3.52859 5.52859Z" fill={fill}/>
        </svg>
    );
};

export default ChevronDown;